import { createContext } from "react";

export const FieldTreeScrollContext = createContext<{
  scrollElement: HTMLDivElement | null;
  contentElement: HTMLDivElement | null;
}>({ scrollElement: null, contentElement: null });
